import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'sb-react-intl'

import s from './Step.scss'


const Step = ({ children, title, desc, options }) => (
  <div className={s.step}>
    <FormattedMessage className={s.title} tag="div" {...title} />
    <FormattedMessage className={s.desc} tag="div" {...desc} />
    <div className={s.options}>
      {
        options.map((option, index) => children(option, index))
      }
    </div>
  </div>
)

Step.propTypes = {
  children: PropTypes.func.isRequired,
  // currIndex: PropTypes.number.isRequired,
  // activeIndex: PropTypes.oneOfType([
  //   PropTypes.number,
  //   null,
  // ]).isRequired,
  title: PropTypes.object.isRequired,
  desc: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
}


export default Step
